// extracted by mini-css-extract-plugin
export var addViewLink = "_q-1";
export var availabilityIcon = "_q-16";
export var availabilitySelectionIcon = "_q-15";
export var backButton = "_q-2";
export var backIcon = "_q-z";
export var conversationCount = "_q-3";
export var dragHandle = "_q-5";
export var dropdown = "_q-e";
export var dropdownIcon = "_q-7";
export var dropdownOption = "_q-6";
export var dropdownTriangle = "_q-d";
export var expand = "_q-f";
export var folder = "_q-i";
export var folderItem = "_q-c";
export var icon = "_q-8";
export var iconRow = "_q-9";
export var image = "_q-a";
export var logo = "_q-b";
export var navContainer = "_q-h";
export var navigationFooter = "_q-g";
export var pageShell = "_q-0";
export var placeholderAvailable = "_q-11";
export var placeholderBox = "_q-14";
export var placeholderBusy = "_q-13";
export var placeholderUnavailable = "_q-12";
export var profile = "_q-k";
export var profileContainer = "_q-m";
export var profileDropdown = "_q-n";
export var profileImage = "_q-l";
export var profileMain = "_q-o";
export var profileSubtitle = "_q-q";
export var profileTitle = "_q-p";
export var reorderIcon = "_q-r";
export var sentLine = "_q-u";
export var settingsHeader = "_q-s";
export var sidenavTextColor = "_q-y";
export var spamLine = "_q-t";
export var subitemWithTag = "_q-4";
export var supportItems = "_q-j";
export var teamText = "_q-10";
export var viewLine = "_q-x";
export var viewLineButton = "_q-w";
export var viewLineButtons = "_q-v";